import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, OnDestroy, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.component.html',
  styleUrls: ['./compliance.component.css']
})
export class ComplianceComponent implements OnInit {

	opened: boolean;
    userName="User";
    companyLogo="giconlylogo.png";
    downLoadPath=this._rest.FILE_PATH;
    analystDashPath = "";
  	constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	const userId = localStorage.getItem('userId');
    if(localStorage.getItem('userName')!= undefined){
      this.userName = localStorage.getItem('userName');
    }
    this.analystDashPath = this._rest.ANALYST_DASH+"/auth/loginWithId/"+userId;
    
    /*if(userId=="1"){
      this.companyLogo= "acko.png";
    } else {
      this.companyLogo= "rsz_abclogo_2x.png";
    }*/
    if(localStorage.getItem('companyLogo')!= undefined && localStorage.getItem('companyLogo')!=""){
      this.companyLogo= localStorage.getItem('companyLogo');
    }
  }

  sideNavToggle(){
    if(document.getElementsByTagName("body")[0].className.match(/open/)){
      this.renderer.removeClass(this.document.body, 'open');
    } else {
      this.renderer.addClass(this.document.body, 'open');
    }
  }
  ddToggleMenu(){
    if(document.getElementById("ddLogout").className.match(/show/)){
      this.renderer.removeClass(document.getElementById("ddMenu"), 'show');
      this.renderer.removeClass(document.getElementById("ddLogout"), 'show');
    } else {
      this.renderer.addClass(document.getElementById("ddMenu"), 'show');
      this.renderer.addClass(document.getElementById("ddLogout"), 'show');
    }
  }
  glogout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
  gochgPsw(){
    this.router.navigate(['/analyst/changepassword']);
    
  }
  goToPage(path,event){
    this.router.navigate([path]);
    //this.renderer.removeClass(this.document.getElementById("mnr").children, 'active');
    //document.getElementById("mnr").children.classList.remove('active');;
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'open');
  }

}
